var Model = require("../types/Model.js");
var IncallManager = require("react-native-incall-manager").default;
var AudioToggle = require("react-native-audio-toggle");
// eslint-disable-next-line node/no-missing-require
var ReactNative = require("react-native");
const { Platform, NativeEventEmitter, NativeModules } = ReactNative;

module.exports = Model({
	name: "audiooutputselector",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	_inBrowser: null,
	_useSpeaker: null,
	_canSwitch: null, // if has headphones plugged in

	setPreference: setPreference,
});

function init() {
	if(Platform.OS === "ios" && AudioToggle?.reset)
		AudioToggle.reset();
	else this._inBrowser = !!(IncallManager.audioGetPlugin === "dissable");
	this.push({
		inBrowser: !this._inBrowser,
		useSpeaker: this._useSpeaker,
		canSwitch: this._canSwitch,
	});
	this._handle_headset_change = handle_headset_change.bind(this);
	this._eventEmitter = Platform.OS === "android" ? new NativeEventEmitter() : new NativeEventEmitter(NativeModules.InCallManager);
	if(this._eventEmitter)
		this._eventEmitter.addListener("WiredHeadset", this._handle_headset_change);
}


function uninit() {
	if(this._eventEmitter && typeof this._eventEmitter.remove === "function")
		this._eventEmitter.remove();
	if(Platform.OS === "ios" && AudioToggle?.reset)
		AudioToggle.reset();
	else IncallManager.stop();

	this._inBrowser = null;
	this._useSpeaker = null;
	this._canSwitch = null;
}

function triggers() {
	return {
		toggle: handle_toggle
	};
}

function listeners() {
	return {
		"calling:updated": handle_calling_update
	};
}

function handle_headset_change(data){
	this._useSpeaker = !data.isPlugged;
	this._canSwitch = !data.isPlugged;
}

function handle_calling_update(data) {
	if(data.state === "connected") {
		if(Platform.OS === "ios") {
			setTimeout(function () {
				AudioToggle.setAudioMode("speaker");
			}, 1500);
			this._useSpeaker = true;
		}
		var callingType = data.voiceOnly ? "audio" : "video";
		var calling = {
			media: callingType
		};
		IncallManager.start(calling);
		IncallManager.setKeepScreenOn(true);
		IncallManager.setForceSpeakerphoneOn(null);
	}
	if(data.state === "idle") {
		if(Platform.OS === "ios") {
			AudioToggle.reset();
		}
		IncallManager.stop();
	}

	this.push({
		useSpeaker: this._useSpeaker,
		inBrowser: this._inBrowser,
		canSwitch: this._canSwitch,
	});
}

function handle_toggle() {
	var newState = !this._useSpeaker;
	if(Platform.OS === "ios") {
		var mode = newState ?  "speaker" : "earpiece";
		AudioToggle.setAudioMode(mode);
	} else {
		IncallManager.setForceSpeakerphoneOn(newState);
	}

	this._useSpeaker = newState;

	if (newState) {
		var message = "connected.speaker";
		this.emit("toast:trigger:show", {
			content: message,
			immediate: true
		});
		this.emit("usermetrics:trigger:track", "audio output changed to speaker in old calling");
	} else {
		message = "connected.earpiece";
		this.emit("toast:trigger:show", {
			content: message,
			immediate: true
		});
		this.emit("usermetrics:trigger:track", "audio output changed to earpiece in old calling");
	}
}

function setPreference(mode) {
	if(this._inBrowser){
		if(Platform.OS !== "ios") {
			IncallManager.audioSetPreference(mode);
		}
	}
}
